import { defineComponent as _defineComponent } from 'vue'
import loading from '@/assets/image/loading-icon.png'
import sendWork from '@/assets/image/send-work.png'
import success from '@/assets/image/success-icon.png'
import wait from '@/assets/image/wait-icon.png'
import ncLoading from '@/assets/ncLoading.png'
import { translate } from '@/util/commonFun'
import {
  computed,
  getCurrentInstance,
  nextTick,
  watch,
  withDefaults,
} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-task-loading',
  props: {
    taskList: { default: () => [] },
    isNcLoading: { type: Boolean, default: false },
    isNowTimeOut: { type: Boolean, default: false },
    isWebToQt: { type: Boolean, default: false },
    title: { default: '' }
  },
  setup(__props: any) {

const props = __props as { taskList: {
      startMsg: string
      startDone: boolean
      endMsg: string
      endDone: boolean
    }[], isNcLoading: boolean, isNowTimeOut: boolean, isWebToQt: boolean, title: string }


const showData = computed(() => {
  const newList = props.taskList.map((it: any) => {
    const { startDone, endDone, startMsg, endMsg } = it
    let type, msg, isLoading, sort, dom
    if (startDone && !endDone) {
      type = loading
      isLoading = true
      msg = startMsg
      sort = 2
      dom = it.type
    } else if (endDone) {
      type = success
      msg = endMsg
      sort = 1
      dom = it.type
    } else {
      type = wait
      msg = startMsg.replace(
        translate('arrangedPage.loadding'),
        translate('arrangedPage.waitLoadding')
      )
      sort = 3
      dom = it.type
    }
    return { type, msg, isLoading, sort, dom }
  })
  // 优先保证完成的任务在前，正在执行的任务居中，等待任务最后
  return newList.sort((a, b) => a.sort - b.sort)
})

// 自动滚动到当前的进度位置
const hasLoadSet = new Set()
const instance = getCurrentInstance()
watch(
  () => props.taskList,
  (newList: any) => {
    newList.forEach((it: any) => {
      if (hasLoadSet.has(it.type)) {
        return
      } else {
        hasLoadSet.add(it.type)
        nextTick(() => {
          ;(
            instance?.proxy.$refs[it.type] as HTMLDivElement[]
          )[0].scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          })
        })
      }
    })
  },
  {
    deep: true,
  }
)

const translateLang = (key: string) => {
  return translate(key)
}

return { __sfc: true,props, showData, hasLoadSet, instance, translateLang, sendWork, ncLoading }
}

})